import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './fashionApparel.css';

import buttonArrow from '../../assets/icons/button-arrow.svg';
import fashionTopModel from '../../assets/fashion-top-model.png';
import fashionSideRetail from '../../assets/fashion-side-retail.png';
import { sendContactEmail } from '../../utils/emailjs';

const FashionApparel = () => {
  const navigate = useNavigate();
  const [newsletterForm, setNewsletterForm] = useState({
    name: '',
    email: '',
    introduction: '',
  });

  const handleNavigateToInquiryForm = () => {
    navigate('/sell-your-business#kw-sell-inquiry');
  };

  useEffect(() => {
    const previousBackground = document.body.style.background;
    document.body.style.background = '#FFFFFF';
    document.body.classList.add('kw__page-hide-backtotop');

    return () => {
      document.body.style.background = previousBackground;
      document.body.classList.remove('kw__page-hide-backtotop');
    };
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setNewsletterForm((current) => ({ ...current, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    await sendContactEmail(newsletterForm, 'Fashion & Apparel Newsletter');
    setNewsletterForm({
      name: '',
      email: '',
      introduction: '',
    });
  };

  return (
    <div className="kw__fashion-page">
      <section className="kw__fashion-top">
        <div className="kw__fashion-section kw__fashion-top-inner">
          <p className="kw__fashion-outline">Fashion &amp; Apparel</p>

          <div className="kw__fashion-hero-copy">
            <h1>Curating Trends, Scaling Global Apparel Footprints</h1>
            <p>
              The fashion industry moves at the speed of consumer culture. We operate a dynamic fashion and apparel portfolio, managing premier
              retail touchpoints and high-demand clothing brands. By blending market-focused trend curation with structured inventory management,
              we bring contemporary styles directly to active consumer markets-ensuring our retail spaces deliver exactly what modern audiences
              want.
            </p>
          </div>
        </div>

        <img src={fashionTopModel} alt="" className="kw__fashion-top-model" aria-hidden="true" />
      </section>

      <section className="kw__fashion-black-band">
        <div className="kw__fashion-section kw__fashion-black-inner">
          <h2>Inventory Flow Managed — Design to Retail Distribution</h2>
          <p>
            We master the fast-moving complexities of apparel retail, where consumer tastes and seasonal cycles shift continuously. Managing fast
            retail turnover, supply chain logistics, and high-volume storefronts requires strict operational agility. Our disciplined retail
            frameworks ensure optimized stock levels, minimized product lag, and consistent brand presentation across high-traffic commercial
            zones.
          </p>
        </div>
      </section>

      <section className="kw__fashion-scale kw__fashion-section">
        <div className="kw__fashion-scale-copy">
          <h2>Driving Commercial Scale Across the Fashion Landscape</h2>
          <p>
            Building a successful apparel portfolio is about more than just great designs-it is about strategic market placement, scalable retail
            operations, and strong distribution partnerships. Our focus remains on expanding our fashion retail footprint while maintaining absolute
            operational stability. We ensure steady revenue growth, reliable supplier networks, and long-term brand equity across diverse fashion
            segments. This commercial platform is purpose-built for brand partners, retail investors, and apparel professionals who understand that
            retail scale only succeeds when back-end operational strength holds under continuous market pressure.
          </p>
        </div>

        <img src={fashionSideRetail} alt="" className="kw__fashion-scale-image" aria-hidden="true" />
      </section>

      <section className="kw__fashion-cta">
        <div className="kw__fashion-section kw__fashion-cta-inner">
          <h2>Ready to Expand Your Fashion Brand?</h2>
          <p>
            If you are looking to expand your fashion retail footprint, strengthen distribution, scale an apparel brand, or explore strategic
            partnerships, let&apos;s build the next stage of growth together.
          </p>
          <button type="button" className="kw__fashion-cta-btn" onClick={handleNavigateToInquiryForm}>
            <span>Let&apos;s Connect to Discuss</span>
            <img src={buttonArrow} alt="" />
          </button>
        </div>
      </section>

      <section className="kw__fashion-newsletter kw__fashion-section">
        <div className="kw__fashion-news-copy">
          <p className="kw__fashion-news-label">Newsletter</p>
          <h3>Never Miss an Update</h3>
          <p>
            Subscribe to our corporate newsletter to receive quarterly highlights, industry research, and exclusive event invitations directly to
            your inbox.
          </p>
        </div>

        <form className="kw__fashion-news-form" onSubmit={handleSubmit}>
          <div className="kw__fashion-news-row">
            <input name="name" placeholder="Name" value={newsletterForm.name} onChange={handleChange} />
            <input name="email" placeholder="Email address" value={newsletterForm.email} onChange={handleChange} />
          </div>
          <textarea name="introduction" placeholder="Introduction" value={newsletterForm.introduction} onChange={handleChange} />
          <button type="submit" className="kw__fashion-news-submit">
            <span>Submit</span>
            <img src={buttonArrow} alt="" />
          </button>
        </form>
      </section>
    </div>
  );
};

export default FashionApparel;
